import React from 'react';
import * as Sentry from '@sentry/react';
import { config } from '@config';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router-dom';

Sentry.init({
    dsn: 'https://22f7542e36d9769f7ba90127f68ea3a7@o4507764079460352.ingest.de.sentry.io/4511019131535440',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: config.environment,
    enabled: !config.isLocalhost,
    enableLogs: true,
    tracesSampleRate: config.environment === 'production' ? 0.1 : 1.0,
    integrations: [
        Sentry.graphqlClientIntegration({ endpoints: [config.graphUrl] }),
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
    ],
});
